export const getShowCategory = (element) => {
  const showCategory = element.getAttribute("data-show-category");
  return showCategory === undefined || showCategory === "1";
};
